import axios from "axios";
import API_BASE_URL from "./api";

// Tutte le chiamate al backend Minerva portano il cookie di sessione HttpOnly
// (`credentials: "include"` per fetch, `withCredentials` per axios). Nessun token in JS:
// gli header `Authorization` ancora scritti a mano in alcune pagine leggono uno storage
// vuoto ("Bearer null") e il backend li ignora, usando il cookie.
const isOurAPI = (urlStr) => Boolean(API_BASE_URL) && urlStr.startsWith(API_BASE_URL);

const segnalaSessioneScaduta = () => window.dispatchEvent(new CustomEvent("token-expired"));

export default function setupAuthFetch() {
  const originalFetch = window.fetch;

  window.fetch = async (url, options = {}) => {
    const urlStr = typeof url === "string" ? url : url.toString();

    if (!isOurAPI(urlStr)) {
      return originalFetch(url, options);
    }

    options = options || {};
    options.headers = options.headers || {};

    const isFormData =
      options.body instanceof FormData ||
      options.headers["Content-Type"] === "multipart/form-data";

    const defaultHeaders = { "ngrok-skip-browser-warning": "true" };
    if (!isFormData) {
      defaultHeaders["Content-Type"] = "application/json";
    }

    options.headers = { ...defaultHeaders, ...options.headers };
    options.credentials = "include";

    const response = await originalFetch(url, options);

    if (response.status === 401) {
      segnalaSessioneScaduta();
    }

    return response;
  };

  // axios non passa da window.fetch: stesso trattamento con un interceptor.
  axios.interceptors.request.use((config) => {
    const completo = `${config.baseURL || ""}${config.url || ""}`;
    if (isOurAPI(completo)) {
      config.withCredentials = true;
    }
    return config;
  });
  axios.interceptors.response.use(
    (r) => r,
    (err) => {
      const completo = `${err?.config?.baseURL || ""}${err?.config?.url || ""}`;
      if (err?.response?.status === 401 && isOurAPI(completo)) {
        segnalaSessioneScaduta();
      }
      return Promise.reject(err);
    }
  );
}
